import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Icon,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const SubSearchPackageUX = (props: any) => {
    return(
      <div
        id="SubSearchPackageUX-div-0"
        style={{width: "100%"}}>
        <div
          id="SubSearchPackageUX-div-4"
          style={{padding: "0 15px"}}>
          
          <Form
            id="SubSearchPackageUX-Form-5">
            <FormGroup
              id="SubSearchPackageUX-FormGroup-6">
              <FormField
                id="SubSearchPackageUX-FormField-8"
                width={4}>
                <label
                  id="SubSearchPackageUX-label-40"
                  style={{fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Package name/code" : "ชื่อ/รหัสแพ็กเกจ"}
                </label>
                <div
                  id="SubSearchPackageUX-div-15"
                  style={{width: "100%"}}>
                  {props.SearchBox}
                </div>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-31"
                width={2}>
                <label
                  id="SubSearchPackageUX-label-37"
                  style={{fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Package Type" : "ชนิดแพ็กเกจ"}
                </label>
                <Dropdown
                  className="inline-label"
                  fluid={true}
                  id="SubSearchPackageUX-Dropdown-34"
                  name="packageType"
                  onChange={props.onChangeValue}
                  options={props.packageTypeOptions|| []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPackage?.packageType || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-33"
                width={2}>
                <label
                  id="SubSearchPackageUX-label-38"
                  style={{fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                </label>
                <Dropdown
                  className="inline-label"
                  fluid={true}
                  id="SubSearchPackageUX-Dropdown-35"
                  name="serviceType"
                  onChange={props.onChangeValue}
                  options={props.packageServiceTypeOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPackage?.serviceType || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-32"
                width={2}>
                <label
                  id="SubSearchPackageUX-label-39"
                  style={{fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Usage status" : "สถานะการใช้งาน"}
                </label>
                <Dropdown
                  className="inline-label"
                  fluid={true}
                  id="SubSearchPackageUX-Dropdown-36"
                  name="status"
                  onChange={props.onChangeValue}
                  options={props.packageStatusOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPackage?.status || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-18"
                style={{display:"none"}}>
                <Button
                  color="red"
                  disabled={!props.allowDelete}
                  id="SubSearchPackageUX-Button-19"
                  onClick={props.onDelete}
                  style={{display: props.allowDelete ? "":"none"}}>
                  
                  <div
                    id="SubSearchPackageUX-div-20"
                    style={{display: "flex", alignItems: "center"}}>
                    
                    <label
                      id="SubSearchPackageUX-label-21"
                      style={{marginRight: "5px"}}>
                      {props.languageUX === "en" ? "delete" : "ลบ"}
                    </label>
                    <Icon
                      id="SubSearchPackageUX-Icon-22"
                      name="trash alternate outline">
                    </Icon>
                  </div>
                </Button>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-9">
                <label
                  id="SubSearchPackageUX-label-41">
                  {"\u00a0"}
                </label>
                <div
                  id="SubSearchPackageUX-div-16">
                  {props.ButtonSearch}
                </div>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-10">
                <label
                  id="SubSearchPackageUX-label-42">
                  {"\u00a0"}
                </label>
                <Button
                  color="yellow"
                  id="SubSearchPackageUX-Button-17"
                  onClick={props.onClear}>
                  {props.languageUX === "en" ? "clear" : "เคลียร์"}
                </Button>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-23"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-7">
                <label
                  id="SubSearchPackageUX-label-43">
                  {"\u00a0"}
                </label>
                <Button
                  color="green"
                  id="SubSearchPackageUX-Button-11"
                  onClick={props.onAddNewPackage}
                  style={{minWidth: "max-content"}}>
                  <div
                    id="SubSearchPackageUX-div-12"
                    style={{display: "flex", alignItems: "center"}}>
                    
                    <Icon
                      id="SubSearchPackageUX-Icon-13"
                      name="plus">
                    </Icon>
                    <label
                      id="SubSearchPackageUX-label-14">
                      {props.languageUX === "en" ? "Add new package" : "เพิ่มแพ็กเกจใหม่"}
                    </label>
                  </div>
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="SubSearchPackageUX-FormGroup-24">
              <FormField
                id="SubSearchPackageUX-FormField-25"
                width={16}>
                <Table
                  data={props.packageList||[]}
                  getTdProps={props.onGetTdProps}
                  getTrProps={props.onGetTrProps}
                  headers="รหัส,ชื่อแพ็กเกจ (EN),ชื่อแพ็กเกจ (TH),ชนิดแพ็กเกจ,ประเภทบริการ,ราคา Normal,ราคา Premium,ราคาต่างชาติ,สถานะใช้งาน,"
                  id="SubSearchPackageUX-Table-26"
                  keys="code,name_en,name,package_type_name,package_service_type_name,price_normal,price_premium,price_foreign,status_name,action"
                  minRows={props.showDetail?3:12}
                  showPagination={false}
                  style={{height: props.showDetail?"calc(100dvh - 44rem)": "calc(100dvh - 19rem)"}}
                  widths="130,^150,^150,^100,^100,^70,^70,^70,^75,100">
                </Table>
              </FormField>
            </FormGroup>
            <FormGroup
              id="SubSearchPackageUX-FormGroup-27"
              inline={true}>
              <FormField
                id="SubSearchPackageUX-FormField-28"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="SubSearchPackageUX-FormField-29">
                <div
                  id="SubSearchPackageUX-div-30">
                  {props.Pagination}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default SubSearchPackageUX

export const screenPropsDefault = {"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Fri Sep 04 2026 10:50:32 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 15px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Form",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Form-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 7,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Button-11"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddNewPackage"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Icon",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Icon-13"
        },
        "name": {
          "type": "value",
          "value": "plus"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มแพ็กเกจใหม่",
          "valueEN": "Add new package"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBox"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-div-16"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-18"
        },
        "style": {
          "type": "code",
          "value": "{display:\"none\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Button",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "code",
          "value": "!props.allowDelete"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Button-19"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDelete"
        },
        "style": {
          "type": "code",
          "value": "{display: props.allowDelete ? \"\":\"none\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ลบ",
          "valueEN": "delete"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-21"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Icon",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Icon-22"
        },
        "name": {
          "type": "value",
          "value": "trash alternate outline"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-23"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormGroup-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-25"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 26,
      "name": "Table",
      "parent": 25,
      "props": {
        "data": {
          "type": "code",
          "value": "props.packageList||[]"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.onGetTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetTrProps"
        },
        "headers": {
          "type": "value",
          "value": "รหัส,ชื่อแพ็กเกจ (EN),ชื่อแพ็กเกจ (TH),ชนิดแพ็กเกจ,ประเภทบริการ,ราคา Normal,ราคา Premium,ราคาต่างชาติ,สถานะใช้งาน,"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Table-26"
        },
        "keys": {
          "type": "value",
          "value": "code,name_en,name,package_type_name,package_service_type_name,price_normal,price_premium,price_foreign,status_name,action"
        },
        "minRows": {
          "type": "code",
          "value": "props.showDetail?3:12"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props.showDetail?\"calc(100dvh - 44rem)\": \"calc(100dvh - 19rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "130,^150,^150,^100,^100,^70,^70,^70,^75,100"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormGroup-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-28"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-29"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "props.Pagination"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-div-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-FormField-33"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Dropdown",
      "parent": 31,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Dropdown-34"
        },
        "name": {
          "type": "value",
          "value": "packageType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageTypeOptions|| []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPackage?.packageType || \"\""
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Dropdown",
      "parent": 33,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Dropdown-35"
        },
        "name": {
          "type": "value",
          "value": "serviceType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageServiceTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPackage?.serviceType || \"\""
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Dropdown",
      "parent": 32,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-Dropdown-36"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageStatusOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPackage?.status || \"\""
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "ชนิดแพ็กเกจ",
          "valueEN": "Package Type"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-37"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการใช้งาน",
          "valueEN": "Usage status"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-39"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ/รหัสแพ็กเกจ",
          "valueEN": "Package name/code"
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-40"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-41"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-42"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "SubSearchPackageUX-label-43"
        }
      },
      "seq": 11,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "SubSearchPackageUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
